import { LILAC_200, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getDynamicDataCardWidgetStyles = function getDynamicDataCardWidgetStyles(buttonType, showLogo, infoTagMarginBottom) {
  if (buttonType === void 0) {
    buttonType = 'primary';
  }
  return StyleSheet.create({
    container: {
      flex: 1
    },
    sectionTitle: {
      zIndex: tokens.spacing.SPACING_5
    },
    infoSection: {
      flex: 1
    },
    cardValueUnit: {
      marginBottom: tokens.spacing.SPACING_2
    },
    button: Object.assign({
      marginTop: tokens.spacing.SPACING_8
    }, buttonType === 'tertiary' && {
      alignSelf: 'flex-start'
    }),
    infoType: {
      marginTop: tokens.spacing.SPACING_8
    },
    animationText: {
      alignSelf: 'center'
    },
    imageContainerCard: {
      aspectRatio: 1.95,
      width: '100%'
    },
    cardOuterContainer: {
      flex: 1,
      overflow: 'hidden'
    },
    imageCard: {
      height: '100%',
      width: '100%'
    },
    contentContainer: {
      padding: tokens.spacing.SPACING_12,
      paddingTop: showLogo ? tokens.spacing.SPACING_24 : tokens.spacing.SPACING_8,
      alignItems: 'baseline'
    },
    logoContainerCard: {
      position: 'absolute',
      bottom: -tokens.spacing.SPACING_16,
      left: tokens.spacing.SPACING_6,
      zIndex: 1,
      height: tokens.spacing.SPACING_36,
      width: tokens.spacing.SPACING_36,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8,
      borderWidth: 0.67,
      borderColor: LILAC_200,
      overflow: 'hidden'
    },
    logoCard: {
      height: '100%',
      width: '100%'
    },
    textWrapper: {
      width: '100%'
    },
    buttonWrapper: {
      marginTop: tokens.spacing.SPACING_12
    },
    headingContainerStyle: {
      marginBottom: tokens.spacing.SPACING_4
    },
    descriptionContainerStyle: {
      marginBottom: tokens.spacing.SPACING_4,
      display: 'flex'
    },
    ctaContainerStyle: {
      position: 'absolute',
      bottom: tokens.spacing.SPACING_12,
      left: tokens.spacing.SPACING_12
    },
    infoIconTooltip: {
      position: 'absolute',
      top: 0,
      zIndex: 99999,
      marginTop: tokens.spacing.SPACING_8,
      marginLeft: tokens.spacing.SPACING_14
    },
    infoTagMargin: {
      marginBottom: infoTagMarginBottom !== null && infoTagMarginBottom !== void 0 ? infoTagMarginBottom : tokens === null || tokens === void 0 ? void 0 : tokens.spacing.SPACING_0
    }
  });
};